import React from "react";
import getClassName from "../../utilities/getClassName";
import AmenityRow from "./AmenityRow";
import wifiIcon from "../../assets/icons/wifi-dark.svg";
import smokingIcon from "../../assets/icons/smoking-dark.svg";
import cabinCrewIcon from "../../assets/icons/cabin-crew-dark.svg";
import petsIcon from "../../assets/icons/pets-dark.svg";
import bedIcon from "../../assets/icons/bed-dark.svg";
import pilotsIcon from "../../assets/icons/pilots-dark.svg";
import subjectToWeightIcon from "../../assets/icons/subject-to-weight-dark.svg";
import subjectToConditionsIcon from "../../assets/icons/subject-to-conditions-dark.svg";
import chevronDownIcon from "../../assets/icons/chevron-down-dark.svg";
import co2Icon from "../../assets/icons/co2.svg";

const formatPets = (content) => {
    if (content.pets !== undefined && content.pets !== null) return String(content.pets);
    if (content.numberOfPets !== undefined && content.numberOfPets !== null) return String(content.numberOfPets);
    return "0";
};

const showPets = (content) => {
    const p = content.pets !== undefined && content.pets !== null ? content.pets : null;
    const n = content.numberOfPets !== undefined && content.numberOfPets !== null ? content.numberOfPets : null;
    return (p != null && p !== 0) || (n != null && n !== 0);
};

const showBed = (content) => {
    const bed = content.bed;
    if (bed == null || bed === "") return false;
    const v = String(bed).trim().toLowerCase();
    if (v === "no" || v === "n" || v === "0") return false;
    if (bed === 0) return false;
    return v === "yes" || v === "y" || v === "1" || bed === 1;
};

const showSmoking = (content) => content.smokingOption === "Y";

const hasSubjectToFields = (content) =>
    content.subjectToWeight === "Y" || (content.subjectToConditions && content.subjectToConditions !== "None");

const getWifiValue = (content) =>
    content.wifiOption === "No WIFI Available"
        ? "No WiFi Available"
        : content.wifiOption || (content.wifi ? "Yes" : "No WiFi Available");

const AircraftCardFeatures = ({ content, showMoreAmenities, onShowMoreToggle, showAll = false }) => (
    <>
        {content.ownerApproval === "Y" && <AmenityRow icon={wifiIcon} name="WiFi" value={getWifiValue(content)} />}
        <AmenityRow
            icon={pilotsIcon}
            name="Pilots"
            value={
                content.numberOfPilots !== undefined && content.numberOfPilots !== null ? content.numberOfPilots : "-"
            }
        />
        <AmenityRow
            icon={cabinCrewIcon}
            name="Flight Attendant"
            value={content.flightAttendants === "Y" || content.has_Flight_Attendant === "Y" ? "Yes" : "No"}
        />
        {showPets(content) && <AmenityRow icon={petsIcon} name="Pets" value={formatPets(content)} />}
        {showBed(content) && <AmenityRow icon={bedIcon} name="Bed" value={content.bed} />}
        {showSmoking(content) && <AmenityRow icon={smokingIcon} name="Smoking" value="Yes" />}
        {content.co2 !== undefined && content.co2 !== null && (
            <AmenityRow icon={co2Icon} name="CO₂" value={`${Number(content.co2).toFixed(2)}T`} />
        )}
        {hasSubjectToFields(content) && (
            <>
                {(showMoreAmenities || showAll) && (
                    <>
                        {content.subjectToWeight === "Y" && (
                            <AmenityRow icon={subjectToWeightIcon} name="Subject to Weight" value="Yes" italic />
                        )}
                        {content.subjectToConditions && content.subjectToConditions !== "None" && (
                            <AmenityRow
                                icon={subjectToConditionsIcon}
                                name="Subject to Conditions"
                                value={content.subjectToConditions}
                                italic
                            />
                        )}
                    </>
                )}
                {!showAll && (
                    <button className="aircraft-card-extra-content__show-more" onClick={onShowMoreToggle}>
                        <img
                            src={chevronDownIcon}
                            alt=""
                            className={getClassName([
                                "aircraft-card-extra-content__show-more-icon",
                                showMoreAmenities && "aircraft-card-extra-content__show-more-icon--open",
                            ])}
                        />
                        <span>{showMoreAmenities ? "Show less" : "Show more"}</span>
                    </button>
                )}
            </>
        )}
    </>
);

export default AircraftCardFeatures;
